import { useState } from "react";
import { Body, Button, Headline, Input } from "~/ui-library";

export type ArticleEmailSubscribeProps = {
  kicker: string;
  title: string;
  description: string;
  defaultInputValue: string;
  buttonText: string;
  onSubmit?: () => void;
};

export const ArticleEmailSubscribe: React.FC<ArticleEmailSubscribeProps> = ({
  kicker,
  title,
  description,
  defaultInputValue,
  buttonText,
  onSubmit,
}) => {
  const [inputValue, setInputValue] = useState<string>(defaultInputValue);
  return (
    <div className="bg-primary-50 px-s py-m">
      <Body size="extraSmall" bold className="text-primary">
        {kicker}
      </Body>
      <Headline className="pt-xs" level={4}>
        {title}
      </Headline>
      <Body className="pt-xs" size="small">
        {description}
      </Body>
      <div className="flex w-full flex-wrap pt-m sm:flex-nowrap">
        <Input
          fullWidth
          label="Subscribe:"
          hideLabel={true}
          onChange={(e) => setInputValue(e.target.value)}
          value={inputValue}
        ></Input>
        <Button
          variant="primary"
          className="mt-xxs sm:ml-xxs sm:mt-[0] md:ml-xs"
          onClick={onSubmit}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};
